<style scoped="scoped" lang="scss"></style>
<style>
/* 重写全局 hiprint 样式 */
.hiprint-headerLine,
.hiprint-footerLine {
  border-color: #1890ff !important;
}

.hiprint-headerLine:hover,
.hiprint-footerLine:hover {
  border-top: 3px dashed #1890ff !important;
}

.hiprint-headerLine:hover:before {
  content: '页眉线';
  left: calc(50% - 18px);
  position: relative;
  background: #ffff;
  top: -14px;
  color: #1890ff;
  font-size: 12px;
}

.hiprint-footerLine:hover:before {
  content: '页脚线';
  left: calc(50% - 18px);
  position: relative;
  color: #1890ff;
  background: #ffff;
  top: -14px;
  font-size: 12px;
}
</style>
<style scoped>
/* 区域 */
.left {
  background: white;
  border: 1px solid #d9d9d9;
  padding: 10px;
  overflow: auto;
  box-sizing: border-box;
}

.center {
  margin: 0 10px;
  background: white;
  border: 1px solid #d9d9d9;
  padding: 14px;
  overflow: auto;
}

.right {
  background: white;
  border: 1px solid #d9d9d9;
  padding: 10px;
  overflow: auto;
}

/* 左侧拖拽元素样式 */
.title {
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  margin: 10px 0 0 24px;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 80px;
  min-height: 60px;
}

.item {
  padding: 10px;
  text-align: center;
}

.item img {
  width: 28px;
  height: auto;
}

.item span {
  color: #1890ff;
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
}
</style>
<template>
  <div v-loading="loading">
    <div v-if="isPreview" :style="{ width: paperWidth * scale + 10 + 'px', height: paperHeight * scale + 10 + 'px' }" style="overflow: auto;">

      <embed v-if="dataUrl !== null" :width="paperWidth * scale" :height="paperHeight * scale" :src="dataUrl + '#toolbar=0'"></embed>

    </div>

  </div>
</template>

<script type="text/javascript">
import { boolean } from 'mathjs';

import { hiprint, defaultElementTypeProvider, disAutoConnect } from 'vue-plugin-hiprint';
export default {
  name: 'yi_print_preview',
  components: {},
  data() {
    return {
      loading: false,
      hiprintTemplate: null,
      dataUrl: null,
      paperHeight: 0,
      paperWidth: 0,
      template: null,

    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true
    },
    address: {
      type: String,
      default: 'http://127.0.0.1:9090/printRemotePDF'
    },
    scale: {
      type: Number,
      default: 1
    },
    printTemplateId: {
      type: Number,
      default: null
    },
    printDatas: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    printTemplateId: {
      handler(n, o) {
        console.log(n, o);
        if (n != o) {
          this.getTemplate();
        }
      },
      immediate: true
    },
    printDatas: {
      handler(n, o) {
        if (n != o) {
          this.getTemplate();
        }
      },
      immediate: true
    }
  },
  computed: {},
  created() {
    // 初始化 provider
    disAutoConnect()
    hiprint.init({
      providers: [defaultElementTypeProvider()]
    });

    this.hiprintTemplate = new hiprint.PrintTemplate({

    });


  },
  destroyed() { },
  mounted() {

  },
  methods: {
    getTemplate() {
      let params = {
        id: this.printTemplateId
      };
      this.http.get('/web/print/template/get', { params: params }).then(res => {
        this.template = res.data
        this.updateJson();
      });
    },
    updateJson() {
      this.hiprintTemplate = new hiprint.PrintTemplate({

      });
      if (this.hiprintTemplate) {
        try {
          let jsonObj = JSON.parse(this.template.templateContent);
          this.paperHeight = jsonObj.panels[0].height;
          this.paperWidth = jsonObj.panels[0].width;

          this.hiprintTemplate.update(jsonObj);

          this.makePreview();
        } catch (e) {
          this.utils.errorMessage('显示模板失败' + e);
        }
      }
    },
    makePreview() {

      if (this.isPreview == false) {
        return;
      }
      this.dataUrl = null;
      if (this.printDatas.length > 0) {
        this.hiprintTemplate.toPdf(this.printDatas[0], '预览pdf', {
          isDownload: false,
          type: 'bloburl',
          scale: 2 // 提高清晰度，值越大越清晰（建议2-3）
        }).then(res => {
          this.dataUrl = res
        });
      }
    },

    print2() {
      this.hiprintTemplate.print(this.printDatas, {}, {
        callback: () => {
        }
      })
    },


    print() {
      let datas = this.printDatas.map(item => {
        return JSON.stringify(item)
      })
      let params = {
        template: this.template.templateContent,
        datas: datas,
        isVertical: this.template.vertical === 1,
      }
      this.http
        .post(this.address, params)
        .then(res => {
          this.utils.successMessage("正在打印");
          this.$emit('finishPrint');

        })
        .catch(err => {
          this.utils.errorMessage(err);
          this.$emit('failedPrint');

        })
        .finally(() => {
        });
    },

    printPdf() {

      this.hiprintTemplate.toPdf(this.printDatas, '预览pdf', {
        isDownload: false,
        type: 'blob',
        scale: 2 // 提高清晰度，值越大越清晰（建议2-3）
      }).then(blob => {
        // 将blob转换为base64
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result.split(',')[1];

          let params = {
            pdf: base64data,
            isVertical: this.template.vertical === 1,
          }

          this.http
            .post('http://127.0.0.1:9090/pirntPdf', params)
            .then(res => {
              this.utils.successMessage("正在打印");
              this.$emit('finishPrint');
            })
            .catch(err => {
              this.utils.errorMessage(err);
              this.$emit('failedPrint');
            });
        }
      });
    },

    toPrint(local = false) {
      if (local) {
        // 本地打印：直接调用 hiprint 的打印 API
        if (hiprint.hiwebSocket && hiprint.hiwebSocket.opened) {
          // 使用 print2 方法进行静默打印
          this.hiprintTemplate.print2({});
        } else {
          // 使用标准 print 方法
          this.hiprintTemplate.print(this.printDatas, {}, {
            callback: () => {
              this.utils.successMessage("本地打印完成");
              this.$emit('finishPrint');
            }
          });
        }
        return;
      }
      this.hiprintTemplate.toPdf(this.printDatas, '预览pdf', {
        isDownload: false,
        type: 'blob',
        scale: 2 // 提高清晰度，值越大越清晰（建议2-3）
      }).then(blob => {
        // 将blob转换为base64
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result.split(',')[1];

          let params = {
            pdf: base64data,
            isVertical: this.template.vertical === 1,
          }
          this.http
            .post(this.address, params)
            .then(res => {
              this.utils.successMessage("正在打印");
              this.$emit('finishPrint');
            })
            .catch(err => {
              this.utils.errorMessage(err);
              this.$emit('failedPrint');
            });
        }
      });
    },

  }
};
</script>
